export const FETCH_PRODUCTS = 'ACCOUNTS_MARKETPLACE/PRODUCTS_FETCH'
export const SET_FILTERS = 'ACCOUNTS_MARKETPLACE/PRODUCTS_SET_FILTERS'
export const SET_DATA = 'ACCOUNTS_MARKETPLACE/PRODUCTS_SET_DATA'
export const SET_LOADING = 'ACCOUNTS_MARKETPLACE/PRODUCTS_SET_LOADING'
export const DROP_DATA = 'ACCOUNTS_MARKETPLACE/PRODUCTS_DROP_DATA'
